import { useDispatch } from 'react-redux';
import { NOTIFICATION_SUBMIT_ACTION } from '../../../api/api';
import { useAxios } from '../../../hooks/useAxios';
import { useObjectState } from '../../../hooks/useObjectState';
import { ACTIONS } from '../Constants';
import { showNotification } from '../../../redux/notifications/actions';
import { notifications } from '../../../constants';

const initialState = { feedbackVote: null, feedbackMessage: '' };

const useNotificationFeedbackController = ({ data, onClose }) => {
  const dispatch = useDispatch();
  const notificationMessageId = data?.notification_message_id;
  const [state, setState] = useObjectState(initialState);

  const { callAxios: submitFeedback, isLoading: isSubmittingFeedback } = useAxios({
    url: NOTIFICATION_SUBMIT_ACTION,
    method: 'post',
    callOnMount: false,
    onSuccess: () => onClose(),
    onError: (err) => {
      dispatch(showNotification(err || notifications.ERROR.something_wrong, 'error'));
    },
  });

  const handleFeedbackVote = (vote) => setState({ feedbackVote: vote });
  const handleFeedbackmessage = (value) => setState({ feedbackMessage: value });
  const handleSubmitFeedback = () => {
    const payload = {
      notification_message: notificationMessageId,
      action: ACTIONS.RECORD_FEEDBACK,
      action_data: {
        inapp_notification_id: data?.id,
        description: state.feedbackMessage,
        is_helpful: state.feedbackVote,
      },
    };

    submitFeedback({
      data: payload,
    });
  };

  const handlers = { handleFeedbackVote, handleFeedbackmessage, handleSubmitFeedback };

  return [{ ...state, isSubmittingFeedback }, handlers];
};

export default useNotificationFeedbackController;
